import { Component } from "@angular/core";
import { Router, RouterModule } from "@angular/router";

@Component({
  selector: "app-redirect",
  standalone: true,
  imports: [RouterModule],
  templateUrl: "./redirect.component.html",
  styleUrls: ["./redirect.component.scss"],
})
export class RedirectComponent {
  constructor(private router: Router) {
    if (localStorage.getItem("currentUser")) {
      this.router.navigate(["app/home"]);
    } else {
      this.router.navigate(["sign/login"]);
    }
  }
}
